export enum SectionTypeEnum {
  DESCRIPTION = 'DESCRIPTION',
  WHATSINTHEBOX = 'WHATSINTHEBOX',
  CHARACTERISTICS = 'CHARACTERISTICS',
  REVIEWS = 'REVIEWS'
}
